
export type Callback<T> = (value: T) => void
export type CallbackFunction<T> = (callback: Callback<T>) => void

export function callbackAsPromise<T>(fn: CallbackFunction<T>): Promise<T>
{
    return new Promise<T>((resolve, reject) =>
    {
        try
        {
            fn(resolve);
        }
        catch (error)
        {
            reject(error);
        }
    });
}